import constants from 'common/helpers/constants'


type PostponedItem = {
  brand: string
  name: string
  image: string
}

const getPostponedItem = (state: ReduxState, isQueueOrderCOGSEnabled: boolean): Partial<PostponedItem> => {
  const {
    models: { queue: { items } },
    view: { pickPage: { selectedItems = [] }, paymentPage: { pickedProducts } },
  } = state

  let firstSelectedItem = selectedItems[0]

  // The backend mixes the goods that were added to the pick page,
  // we need to find the product that was added to the queue first on the backend.
  if (isQueueOrderCOGSEnabled && pickedProducts && pickedProducts.length) {
    const firstItemId    = pickedProducts[0]
    const firstCOGSItem  = selectedItems.find(({ id }) => id === firstItemId) || {}

    if (firstCOGSItem && firstCOGSItem.brand && firstCOGSItem.name) {
      firstSelectedItem = firstCOGSItem
    }
  }

  const firstQueueItem        = items[0] && items[0].products[0]
  const hasProductInQueue     = Boolean(firstQueueItem && firstQueueItem.brand && firstQueueItem.name)
  const postponedItem         = hasProductInQueue ? firstQueueItem : firstSelectedItem

  if (postponedItem) {
    return postponedItem
  }

  let postponedQueueProduct

  try {
    const postponedQueueProductStorage = JSON.parse(localStorage.getItem(constants.localStorageNames.queueProduct))

    if (postponedQueueProductStorage) {
      postponedQueueProduct = postponedQueueProductStorage.item
    }
  }
  catch (err) {
    console.error(err)
  }

  // for not logged in users who pick a product on product page
  if (postponedQueueProduct && postponedQueueProduct.brand && postponedQueueProduct.name) {
    const { productImage, image, img, ...rest } = postponedQueueProduct

    return { image: productImage || image || img, ...rest }
  }

  return {}
}


export default getPostponedItem
